import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Button, CircularProgress } from "@mui/material";
import { useUpdateMerchantStatusMutation } from "Api/Mutations/Merchants/useUpdateMerchantStatusMutation";
import { MerchantStatus } from "Infrastructure/Api/Api";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.Merchants.Detail;

type Props = {
  merchantPublicID: string;
};

/**
 * Admin approval of a self-registered (add-role) merchant. Legacy merchants go Active as a side
 * effect of the owner's KYC approval; a self-added merchant belongs to an already-verified person,
 * so this button is the human gate before the merchant goes live (public map, payments).
 */
export const ActivateMerchantButton = ({ merchantPublicID }: Props) => {
  const { t } = useResource();

  const { mutate, isPending } = useUpdateMerchantStatusMutation({
    onSuccess: () => {
      toast.success(t(RESOURCES.ActivateSuccess));
    },
    onError: () => {
      toast.error(t(RESOURCES.ActivateError));
    },
  });

  const handleActivate = () =>
    isPending
      ? undefined
      : mutate({ merchantPublicID, status: MerchantStatus.Active });

  return (
    <Button
      variant="outlined"
      size="small"
      color="success"
      onClick={handleActivate}
      endIcon={
        isPending ? <CircularProgress size={16} /> : <CheckCircleOutlineIcon />
      }
    >
      {t(RESOURCES.ActivateButton)}
    </Button>
  );
};
